import React from 'react';

export enum ScribeStatus {
  STOPPED = 'STOPPED',
  PAUSED = 'PAUSED',
  STARTED = 'STARTED',
}

export interface ScribeContextType {
  isScribing: ScribeStatus;
  timer: number;
  consentModalOpen: boolean;
  setIsScribing: (status: ScribeStatus) => void;
  setTimer: (timer: number) => void;
  setConsentModalOpen: (open: boolean) => void;
  handleStartScribe: () => void;
  handleResumeScribe: () => void;
  handleConsentConfirm: () => void;
  handleConsentCancel: () => void;
  handleStopScribe: () => void;
  handlePause: () => void;
  formatTime: (seconds: number) => string;
}

const initialScribeContext: ScribeContextType = {
  isScribing: ScribeStatus.STOPPED,
  timer: 0,
  consentModalOpen: false,
  setIsScribing: (_status: ScribeStatus): void => {},
  setTimer: (_timer: number): void => {},
  setConsentModalOpen: (_open: boolean): void => {},
  handleStartScribe: (): void => {},
  handleResumeScribe: (): void => {},
  handleConsentConfirm: (): void => {},
  handleConsentCancel: (): void => {},
  handleStopScribe: (): void => {},
  handlePause: (): void => {},
  formatTime: (_seconds: number): string => '',
};

const ScribeContext = React.createContext<ScribeContextType>(initialScribeContext);

export default ScribeContext;
